module.exports = __webpack_public_path__ + "img/rjcEgf@2x.4b81a62.jpg";